import { Epic } from 'redux-observable';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ofType } from '@alycecom/utils';

import {
  dataLoadRequest,
  dataLoadSuccess,
  dataLoadFail,
  accessRequest,
  accessSuccess,
  accessFail,
} from './data.actions';
import { IGiftData } from './data.types';

export const loadDataEpic: Epic = (action$, state$, { apiService, messagesService: { errorHandler } }) =>
  action$.pipe(
    ofType(dataLoadRequest),
    switchMap(({ payload: { hashId } }) =>
      apiService.get(`/api/recipient/${hashId}/data`).pipe(
        map((response: IGiftData) => dataLoadSuccess(response)),
        catchError(errorHandler({ callbacks: dataLoadFail })),
      ),
    ),
  );

export const loadAccessEpic: Epic = (action$, state$, { apiService, messagesService: { errorHandler } }) =>
  action$.pipe(
    ofType(accessRequest),
    switchMap(({ payload: { hashId } }) =>
      apiService.get(`/api/recipient/${hashId}/access`).pipe(
        map(() => accessSuccess()),
        catchError(errorHandler({ callbacks: accessFail })),
      ),
    ),
  );

export const dataEpics = [loadDataEpic, loadAccessEpic];
